<template>
	<div class="manual-assign-rule">
		<div class="page-info">
			<span class="info-tag">手工指定-通用规则</span>
			适用于商品配置的「手工指定」，店铺：
			<span class="shop-name">{{ shopName }}</span>
		</div>

		<div class="form-section">
			<el-form ref="form" v-loading="loading" :model="form" :rules="rules" inline class="config-form" size="medium">
				<el-form-item label="预发日期" prop="pre_delivery_date">
					<el-select v-model="form.pre_delivery_date" placeholder="请选择预发日期">
						<el-option
							v-for="item in shipDateOptions"
							:key="item.value"
							:label="item.label"
							:value="item.value"
						/>
					</el-select>
				</el-form-item>
				<el-form-item class="form-submit">
					<el-button type="primary" :loading="saving" @click="onSave">保存</el-button>
				</el-form-item>
			</el-form>
			<p class="field-tip">渠道预发日期超过此值的不推送；2 日内发货，指渠道预发日期为今日或明日。</p>
		</div>
	</div>
</template>

<script>
import {
	buildManualSavePayload,
	fetchPushConfig,
	getRetailShopId,
	mapManualConfigToForm,
	PUSH_CONFIG_TYPES,
	savePushConfig,
} from './retailShopPushConfig'

const DEFAULT_FORM = {
	shipDays: 3,
	is_enabled: 1,
}

export default {
	name: 'ManualAssignRule',
	inject: {
		retailShop: { default: null },
	},
	data() {
		return {
			loading: false,
			saving: false,
			form: Object.assign({}, DEFAULT_FORM),
			rules: {
				pre_delivery_date: [{ required: true, message: '请选择预发日期', trigger: 'change' }],
			},
			shipDateOptions: [
				{ value: 1, label: '当日发货' },
			].concat(Array.from({ length: 14 }, (_, i) => ({
				value: i + 2,
				label: `${i + 2}日内发货`,
			}))),
		}
	},
	computed: {
		shopName() {
			return (this.retailShop && this.retailShop.shopName) || ''
		},
	},
	watch: {
		'retailShop.currentShopId': {
			immediate: true,
			handler(id) {
				if (id) {
					this.fetchConfig()
				} else {
					this.resetForm()
				}
			},
		},
	},
	methods: {
		resetForm() {
			this.form = Object.assign({}, DEFAULT_FORM)
		},
		applyConfig(data) {
			const mapped = mapManualConfigToForm(data)
			const form = Object.assign({}, DEFAULT_FORM)
			let key
			for (key in mapped) {
				if (mapped[key] !== undefined) {
					form[key] = mapped[key]
				}
			}
			this.form = form
		},
		fetchConfig() {
			const shopId = getRetailShopId(this.retailShop)
			if (!shopId) {
				return
			}
			this.loading = true
			fetchPushConfig(this.$axios, shopId, PUSH_CONFIG_TYPES.MANUAL).then(data => {
				this.applyConfig(data)
			}).catch(err => {
				console.log(err)
				this.$message.error(err.message || '获取手工指定配置失败')
			}).finally(() => {
				this.loading = false
			})
		},
		onSave() {
			this.$refs.form.validate((valid) => {
				if (!valid) return
				const shopId = getRetailShopId(this.retailShop)
				if (!shopId) {
					this.$message.warning('店铺信息不完整')
					return
				}
				this.saving = true
				const payload = buildManualSavePayload(shopId, this.form)
				savePushConfig(this.$axios, payload).then(() => {
					this.fetchConfig()
					this.$message.success('保存成功')
				}).catch(err => {
					console.log(err)
					this.$message.error(err.message || '保存失败')
				}).finally(() => {
					this.saving = false
				})
			})
		},
	},
}
</script>

<style scoped lang="less">
.manual-assign-rule {
	padding: 24px 28px 36px;
	background: #fff;
	min-height: 100%;
	box-sizing: border-box;
}

.page-info {
	margin-bottom: 28px;
	padding: 14px 18px;
	font-size: 14px;
	line-height: 1.6;
	color: #606266;
	background: #fafbfc;
	border-left: 3px solid #67c23a;
	border-radius: 0 6px 6px 0;

	.info-tag {
		display: inline-block;
		margin-right: 8px;
		padding: 2px 10px;
		font-size: 12px;
		color: #409eff;
		background: rgba(64, 158, 255, 0.08);
		border-radius: 3px;
		vertical-align: middle;
	}

	.shop-name {
		color: #ff4714;
		font-weight: 500;
	}
}

.form-section {
	padding-bottom: 8px;
}

.config-form {
	display: flex;
	flex-wrap: wrap;
	align-items: flex-start;

	/deep/ .el-form-item {
		margin-right: 20px;
		margin-bottom: 0;
	}

	/deep/ .el-form-item__label {
		font-size: 12px;
		color: #606266;
		line-height: 36px;
		padding-right: 12px;
	}

	/deep/ .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label::before {
		color: #f56c6c;
	}

	.el-select {
		width: 200px;
	}

	/deep/ .el-input__inner {
		height: 36px;
		line-height: 36px;
		border-color: #e8eaed;
		border-radius: 4px;
		background: #fafbfc;
		transition: all 0.2s;

		&:hover {
			border-color: #dcdfe6;
			background: #fff;
		}

		&:focus {
			border-color: #ff4714;
			background: #fff;
		}
	}

	.form-submit {
		margin-right: 0;

		/deep/ .el-form-item__content {
			margin-left: 0 !important;
		}

		.el-button {
			min-width: 96px;
			height: 36px;
			padding: 0 24px;
			font-size: 12px;
			border-radius: 4px;
			letter-spacing: 1px;
		}
	}
}

.field-tip {
	margin: 14px 0 0;
	padding-left: 2px;
	font-size: 11px;
	color: #b0b3b8;
	line-height: 1.6;
	max-width: 560px;
}
</style>



// WEBPACK FOOTER //
// src/components/StoreConfig/detailed/manualAssignRule.vue